// 서비스 파일 구조

import { api } from "@/comn";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";

/*
 * External user change history service
 * !== 외부사용자 변경이력 서비스 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/usr/xtrnusrhist`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/xtrn-usr-hist`,
    nodes: [
        { path: "/", label: "L_INT_PTL" },
        { path: "/", label: "L_PTL_MGMT" },
    ],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0923001q: `${BASE.path}/ptli0923001q`, // External user change history list !== 외부사용자 변경이력 목록 ==!
    ptli0923002q: `${BASE.path}/ptli0923002q`, // Detailed list of external user change history !== 외부사용자 변경이력 상세 목록 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    getXtrnUsrChgHistList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getXtrnUsrChgHistDtl: (xtrnUsrIdntfNo: any, lcneUsrYn: any) => {
        return api.get(`${BASE.api}/${xtrnUsrIdntfNo}/${lcneUsrYn}`);
    },
    getXtrnUsrChgHistDtlList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/${data.xtrnUsrIdntfNo}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    getXtrnUsrChgHistExcelList: (data: any) => api.get(`${BASE.api}/excel`, { params: comnUtils.toGetParams(data) }),
};

export const SF_XTRN_USR_CHG_HIST_SRCH: TFormSchema = {
    id: "form_XtrnUsrChgHist",
    schema: {
        xtrnUsrIdntfNo: { type: "text", label: "L_USR_ID" },
        usrNm: { type: "text", label: "L_NM" },
        coNm: { type: "text", label: "L_CO_NM" },
        coTin: { type: "text", label: "L_CO_TIN" },
        lcneUsrYn: {
            type: "select",
            label: "L_LCNE_USR_YN",
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
            all: true,
        },
        usrStatCd: { type: "checkbox", label: "L_USR_STAT", area: "comnCd", comnCd: "PTL0001" },
    },
};

export const SG_XTRN_USR_CHG_HIST_LIST: TGridSchema = {
    id: "grid_XtrnUsrChgHistList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_USR_ID", binding: "xtrnUsrIdntfNo", width: "20%" }] },
        { cells: [{ header: "L_USR_HIST_CNT", binding: "usrHistCnt", width: "10%" }] },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "30%" }] },
        //{ cells: [{ header: "L_CO_TIN", binding: "coTin", width: "10%" }] },
        //{ cells: [{ header: "L_CO_NM", binding: "coNm", width: "*" }] },
        { cells: [{ header: "L_LCNE_USR_YN", binding: "lcneUsrYn", width: "8%" }] },
        { cells: [{ header: "L_USR_STAT", binding: "usrStatCdNm", width: "8%" }] },
        { cells: [{ header: "L_LAST_MDFR_ID", binding: "lastMdfrId", width: "10%" }] },
        { cells: [{ header: "L_LAST_MDFY_DTM", binding: "lastMdfyDtm", width: "15%" }] },
    ],
    body: [
        { cells: [{ binding: "xtrnUsrIdntfNo", align: "left" }] },
        { cells: [{ binding: "usrHistCnt", align: "right", type: "number" }] },
        { cells: [{ binding: "usrNm", align: "left" }] },
        // {
        //     cells: [{ binding: "coTin" }],
        // },
        // {
        //     cells: [{ binding: "coNm", align: "left" }],
        // },
        { cells: [{ binding: "lcneUsrYn" }] },
        { cells: [{ binding: "usrStatCdNm", align: "left" }] },
        { cells: [{ binding: "lastMdfrId", align: "left" }] },
        { cells: [{ binding: "lastMdfyDtm", type: "datetime" }] },
    ],
};

export const SG_XTRN_USR_CHG_HIST_DTL_LIST: TGridSchema = {
    id: "grid_XtrnUsrChgHistDtlList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_USR_ID", binding: "xtrnUsrIdntfNo", width: "10%" }] },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "15%" }] },
        { cells: [{ header: "L_CSTM_USR_TELNO", binding: "usrMoblNo", width: "15%" }] },
        { cells: [{ header: "L_CSTM_USR_EML_ADDR", binding: "usrEmlAddr", width: "20%" }] },
        { cells: [{ header: "L_RSDT_ADDR", binding: "rsdtAddr", width: "20%" }] },
        { cells: [{ header: "L_USR_STAT", binding: "usrStatCdNm", width: "10%" }] },
        { cells: [{ header: "L_LAST_MDFR_ID", binding: "lastMdfrId", width: "10%" }] },
        { cells: [{ header: "L_LAST_MDFY_DTM", binding: "lastMdfyDtm", width: "15%" }] },
    ],
    body: [
        { cells: [{ binding: "xtrnUsrIdntfNo", align: "left" }] },
        {
            cells: [{ binding: "usrNm", align: "left" }],
        },
        {
            cells: [{ binding: "usrMoblNo" }],
        },
        {
            cells: [{ binding: "usrEmlAddr", align: "left" }],
        },
        {
            cells: [{ binding: "rsdtAddr", align: "left" }],
        },
        {
            cells: [{ binding: "usrStatCdNm", align: "left" }],
        },
        {
            cells: [{ binding: "lastMdfrId", align: "left" }],
        },
        {
            cells: [{ binding: "lastMdfyDtm" }],
        },
    ],
};

export const SG_XTRN_USR_CHG_HIST_EXCEL_LIST: TGridSchema = {
    id: "grid_XtrnUsrChgHistExcelList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_USR_ID", binding: "xtrnUsrIdntfNo", width: "20%" }] },
        { cells: [{ header: "L_USR_HIST_CNT", binding: "usrHistCnt", width: "10%" }] },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "30%" }] },
        //{ cells: [{ header: "L_CO_TIN", binding: "coTin", width: "10%" }] },
        //{ cells: [{ header: "L_CO_NM", binding: "coNm", width: "*" }] },
        { cells: [{ header: "L_LCNE_USR_YN", binding: "lcneUsrYn", width: "8%" }] },
        { cells: [{ header: "L_USR_STAT", binding: "usrStatCdNm", width: "8%" }] },
        { cells: [{ header: "L_LAST_MDFR_ID", binding: "lastMdfrId", width: "10%" }] },
        { cells: [{ header: "L_LAST_MDFY_DTM", binding: "lastMdfyDtm", width: "15%" }] },
    ],
    body: [
        { cells: [{ binding: "xtrnUsrIdntfNo", align: "left" }] },
        { cells: [{ binding: "usrHistCnt", align: "right", type: "number" }] },
        { cells: [{ binding: "usrNm", align: "left" }] },
        // {
        //     cells: [{ binding: "coTin" }],
        // },
        // {
        //     cells: [{ binding: "coNm", align: "left" }],
        // },
        { cells: [{ binding: "lcneUsrYn" }] },
        { cells: [{ binding: "usrStatCdNm", align: "left" }] },
        { cells: [{ binding: "lastMdfrId", align: "left" }] },
        { cells: [{ binding: "lastMdfyDtm", type: "datetime" }] },
    ],
};